import { FC } from "react";

import { PropsWithClasses } from "web/types/Common";

import classify from "web/classify";

import LoadingNew from "../LoadingNew";
import defaultClasses from "./loading.scss";

const Loading: FC<PropsWithClasses> = ({ classes = {} }) => {
  return (
    <div className={classes.root} data-testid="loading-component">
      <LoadingNew />
      <div className="visually-hidden">Ładowanie</div>
    </div>
  );
};

export default classify<PropsWithClasses>(defaultClasses)(Loading);
